/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
//
// Course-detail public API.
//
// Three variants of the course-detail page:
//   - CourseDetailContentFirst   (default — curriculum-led)
//   - CourseDetailDecisionFirst  (outcomes-led, big sidebar)
//   - CourseDetailTrustFirst     (instructor + reviews above the fold)
//
// All three accept the same props and compose the same shared kit, so
// switching variants in a theme override is a one-line change.

export { CourseDetailContentFirst } from './CourseDetailContentFirst';
export { CourseDetailDecisionFirst } from './CourseDetailDecisionFirst';
export { CourseDetailTrustFirst } from './CourseDetailTrustFirst';

export type { CourseDetailProps } from './shared';
